import Benchmark from './BenchmarkContainer';

export default Benchmark;
